const ar = {
  nav: {
    home: 'الصفحة الرئيسية',
    about: 'معلومات عنا',
    menu: 'القائمة',
    gallery: 'المعرض',
    location: 'الموقع',
    contact: 'اتصل بنا'
  },
  hero: {
    badge: 'أول مقهى تركي على الفحم في تركيا',
    title: 'مولا كوزدة قهوجي',
    subtitle: 'حيث تلتقي ثقافة القهوة التركية التقليدية بفن الطهي على الفحم',
    description: 'تجربة قهوة فريدة على الفحم في قلب كاديكوي',
    exploreMenu: 'اكتشف القائمة',
    visitUs: 'قم بزيارتنا',
    feature1Title: 'الطهي على الفحم',
    feature1Desc: 'نكهة فريدة بطريقة الطهي التقليدية على الفحم',
    feature2Title: 'مفهوم رائد',
    feature2Desc: 'أول وأفضل مفهوم قهوة على الفحم في تركيا',
    feature3Title: 'في كاديكوي',
    feature3Desc: 'في انتظاركم في شارع مودا'
  },
  about: {
    badge: 'قصتنا',
    title: 'أول مقهى',
    titleBold: 'على الفحم في تركيا',
    subtitle: 'تجربة فريدة تمزج ثقافة القهوة التركية التقليدية مع لمسة عصرية منذ عام 1988',
    experience: 'سنوات من الخبرة',
    sectionTitle: 'تجربة قهوة',
    sectionTitleBold: 'فريدة من نوعها',
    paragraph1: 'تأسست مولا كوزدة قهوجي بشغف بدأ في أمينونو عام 1988. بدأت قصتنا بهدف تقديم تجربة لا تُنسى لعشاق القهوة التركية، وفتحت صفحة جديدة بانتقالها إلى كاديكوي في عام 2000. نحن نجمع بين النكهات التقليدية في جو عصري مع أول وأفضل مفهوم قهوة على الفحم في تركيا.',
    paragraph2: 'طريقة الطهي على الفحم ترفع رائحة ونكهة القهوة إلى أعلى مستوى. يتم تحضير كل فنجان قهوة بعناية من قبل خبرائنا ويقدم لك بشكل خاص. بفضل تقنية الطهي الفريدة هذه، ستكتشف النكهة الحقيقية للقهوة.',
    paragraph3: 'نحن لا نقدم القهوة فقط، بل نقدم أيضًا جوًا دافئًا وبيئة ودية. مولا كوزدة قهوجي هي نقطة استراحة حيث يمكنك الالتقاء بأصدقائك وقراءة الكتب وقضاء وقت لنفسك.',
    feature1Title: 'وصفات خاصة',
    feature1Desc: 'وصفات قهوة خاصة محضرة بطرق تقليدية',
    feature2Title: 'مكونات عالية الجودة',
    feature2Desc: 'أفضل حبوب البن والمكونات عالية الجودة',
    feature3Title: 'خبراء القهوة',
    feature3Desc: 'خبراء قهوة ذوو خبرة وشغف',
    feature4Title: 'جو ودي',
    feature4Desc: 'جو دافئ وجذاب',
    charcoalTitle: 'ما هو الطهي على الفحم؟',
    charcoalDesc1: 'الطهي على الفحم هو طريقة طهي القهوة التركية التقليدية ببطء على النار، بحرارة الفحم. تعمل هذه التقنية على رفع رائحة ونكهة القهوة إلى أعلى مستوى. بفضل الحرارة المتساوية للفحم، تتشكل رغوة القهوة بشكل مثالي وتظهر النكهة الحقيقية للقهوة.',
    charcoalDesc2: 'تتطلب طريقة الطهي الخاصة هذه الصبر والمهارة. يتم تحضير كل فنجان قهوة بعناية من قبل خبرائنا ويقدم لك في أنضج حالاته.'
  },
  menu: {
    badge: 'نكهاتنا',
    title: 'قائمتنا',
    subtitle: 'قائمتنا الغنية المحضرة بنكهات تقليدية ووصفات خاصة',
    coffee: 'أنواع القهوة',
    tea: 'أنواع الشاي',
    cold: 'المشروبات الباردة والميلك شيك',
    dessert: 'أنواع الكيك',
    popular: 'شائع',
    close: 'إغلاق',
    vatIncluded: 'الأسعار شاملة ضريبة القيمة المضافة'
  },
  gallery: {
    badge: 'معرض الصور',
    title: 'لحظات من مولا',
    subtitle: 'القصة المرئية لشغفنا بالقهوة وأجوائنا الدافئة',
    followText: 'تابع حسابنا على إنستغرام لمزيد من الصور',
    image1Title: 'تحضير القهوة على الفحم',
    image1Desc: 'قهوتنا المحضرة بالطريقة التقليدية',
    image2Title: 'تقديم خاص',
    image2Desc: 'عروض محضرة بعناية فائقة',
    image3Title: 'أجواء حميمة',
    image3Desc: 'بيئتنا الدافئة والمرحبة',
    image4Title: 'استراحة القهوة',
    image4Desc: 'منظر من بعيد، لحظات هادئة',
    image5Title: 'في أيدي الخبراء',
    image5Desc: 'أساتذة القهوة ذوي الخبرة',
    image6Title: 'مكونات عالية الجودة',
    image6Desc: 'أفضل حبوب القهوة'
  },
  location: {
    badge: 'الموقع',
    title: 'قم بزيارتنا',
    subtitle: 'في انتظاركم في قلب كاديكوي، على شارع موهوردار',
    addressTitle: 'العنوان',
    address: 'جافر آغا، شارع موهوردار رقم 25، 34710 كاديكوي/إسطنبول',
    getDirections: 'احصل على الاتجاهات',
    contactTitle: 'اتصل',
    callNow: 'اتصل الآن',
    transportTitle: 'المواصلات',
    transport1: 'مترو كاديكوي - على بعد 5 دقائق سيرًا على الأقدام',
    transport2: 'على بعد دقيقتين سيرًا على الأقدام من محطات الحافلات',
    transport3: 'مواقف سيارات متاحة في المنطقة المجاورة',
    openInMaps: 'افتح في خرائط Google'
  },
  contact: {
    phone: 'الهاتف',
    address: 'العنوان'
  },
  footer: {
    description: 'تجربة فريدة تجمع بين ثقافة القهوة التركية التقليدية وفن الطهي على الفحم.',
    quickLinks: 'روابط سريعة',
    about: 'معلومات عنا',
    menu: 'القائمة',
    gallery: 'المعرض',
    location: 'الموقع',
    contact: 'اتصل بنا',
    contactInfo: 'معلومات الاتصال',
    workingHours: 'ساعات العمل',
    everyday: 'كل يوم',
    open247: 'مفتوح 24/7',
    reservation: 'الحجز',
    reservationNote: 'يرجى الاتصال مسبقًا لحجوزات المجموعات.',
    copyright: '© 2025 مولا كوزدة قهوجي. جميع الحقوق محفوظة.'
  }
};

export default ar;